import { http } from "@/config/httpCommon"
export default {
    state: {
        email_templates: [],
    },
    mutations: {
        SET_EMAIL_TEMPLATE(state, payload) {
            state.email_templates = payload;
        },
        ADD_EMAIL_TEMPLATE(state, payload){
            state.email_templates.push(payload);
        },
        UPDATE_EMAIL_TEMPLATE(state, payload){
            state.email_templates = state.email_templates.map(item => {
                if(item.id === payload.id)
                    return payload;
                else
                    return item;
            });
        },
        DELETE_EMAIL_TEMPLATE(state, id){
            let index = state.email_templates.findIndex(item => item.id == id);
            state.email_templates.splice(index, 1);
        },
        DELETE_MORE_Email_Templates(state, ids){
            ids.forEach(id => {
                let index = state.email_templates.findIndex(item => item.id == id);
                state.email_templates.splice(index, 1);
            });
        }
    },
    getters:{
        getEmailTemplates(state){
            return state.email_templates;
        },
    },
    actions: {
        async createEmailTemplates({commit}, payload){
            let res = await http.post(`email-templates`, payload).catch(error => {
                return error.response
            });
            if(res) {
                commit('ADD_EMAIL_TEMPLATE', res.data.data);
                return res;
            }
        },
        async getEmailTemplates({commit},payload=''){
            let res = await http.get(`email-templates`+payload);
            commit('SET_EMAIL_TEMPLATE', res.data.data);
            return res;
        },
        async updateEmailTemplates({commit}, payload){
            let res = await http.patch(`email-templates/${payload.id}`, payload);
            console.log('res', res.data.data);
            commit('UPDATE_EMAIL_TEMPLATE', res.data.data);
            return res;
        },
        async deleteEmailTemplate({commit}, id){
            await http.delete(`email-templates/${id}`);
            commit('DELETE_EMAIL_TEMPLATE', id);
        },
        async deleteEmailTemplates({commit}, payload){
            await http.post(`delete-email-templates`, payload);
            commit('DELETE_MORE_Email_Templates', payload.ids);
        },
    }
}
